export const noteWidth = 30;
export const noteHeight = 5;
export const verticalSizeNum = 384;
export const editorHeight = verticalSizeNum;
export const quarterInterval = verticalSizeNum / 8;
export const fps = 60;

export const canvasMarginHorizontal = 50;
export const canvasMarginVertical = 25;

export const noteColors = ["#ff0000", "#0000ff", "#00cc00", "#ff9000"];
export const freezeColors = ["#ff4dd2", "#00ffff", "#ceff00", "#c99b7d"];
export const laneColors = ["#fff0ff", "#f0f0ff", "#f0fff0", "#fff0dd"];
